export class Erro {
  nome: string = null;
  mensagem: string = null;

  constructor(d?) {
    if (d) {
      this.nome = d.nome ? d.nome : null;
      this.mensagem = d.mensagem ? d.mensagem : null;
    }
  }
}
